import {
  BrickWall, Wrench, Zap, Paintbrush, Grid3x3, TreeDeciduous, Flame, Snowflake,
  Construction, Shield, Sparkles, Warehouse, Lock, Square, TreePine, Waves,
  ShowerHead, CookingPot, Package, Layers, HardHat, Wind, Sun, Accessibility,
  type LucideIcon
} from 'lucide-react';

export interface PictogrammeEquipe {
  id: string;
  label: string;
  icon: LucideIcon;
}

export const PICTOGRAMMES_EQUIPE: PictogrammeEquipe[] = [
  // Gros œuvre
  { id: 'Construction', label: 'Gros œuvre', icon: Construction },
  { id: 'BrickWall', label: 'Maçonnerie', icon: BrickWall },
  { id: 'HardHat', label: 'Démolition', icon: HardHat },

  // Second œuvre
  { id: 'Wrench', label: 'Plomberie', icon: Wrench },
  { id: 'Zap', label: 'Électricité', icon: Zap },
  { id: 'Flame', label: 'Chauffage', icon: Flame },
  { id: 'Snowflake', label: 'Climatisation', icon: Snowflake },
  { id: 'Wind', label: 'Ventilation / VMC', icon: Wind },
  { id: 'ShowerHead', label: 'Salle de bain', icon: ShowerHead },
  { id: 'CookingPot', label: 'Cuisine', icon: CookingPot },
  { id: 'Package', label: 'Placo / Cloisons', icon: Package },
  { id: 'Layers', label: 'Isolation', icon: Layers },
  { id: 'Shield', label: 'Étanchéité', icon: Shield },

  // Finitions
  { id: 'Paintbrush', label: 'Peinture', icon: Paintbrush },
  { id: 'Grid3x3', label: 'Carrelage', icon: Grid3x3 },
  { id: 'TreeDeciduous', label: 'Menuiserie / Parquet', icon: TreeDeciduous },
  { id: 'Sparkles', label: 'Revêtement de sol', icon: Sparkles },
  { id: 'Square', label: 'Vitrerie / Miroiterie', icon: Square },

  // Toiture
  { id: 'Warehouse', label: 'Couverture / Toiture', icon: Warehouse },
  { id: 'Sun', label: 'Panneaux solaires', icon: Sun },

  // Extérieur
  { id: 'TreePine', label: 'Paysagiste', icon: TreePine },
  { id: 'Waves', label: 'Pisciniste', icon: Waves },

  // Spécialisé
  { id: 'Lock', label: 'Serrurerie', icon: Lock },
  { id: 'Accessibility', label: 'Accessibilité PMR', icon: Accessibility },
];

// Helper pour trouver un pictogramme par son id
export function getPictogrammeEquipeById(id: string): PictogrammeEquipe | undefined {
  return PICTOGRAMMES_EQUIPE.find(p => p.id === id);
}
